module.exports = __webpack_public_path__ + "img/dog.967d011c.png";